import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// NavigationTracker — rastreia navegação do usuário.
// O appLogs do Base44 foi removido; adicione sua própria solução de analytics aqui se desejar.
export default function NavigationTracker() {
  const location = useLocation();

  useEffect(() => {
    // Exemplo: console.log ou integre com PostHog, Mixpanel, etc.
    // console.log('Navegou para:', location.pathname);
  }, [location]);

  return null;
}
